module.exports = __webpack_public_path__ + "static/media/characterOne.22c67d3b.svg";